/*@ngInject*/
const CreateCollaborationNoteRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.createCollaborationNote = function (data) {
        let url = '/rest/Note',
            config = {
                params: data
            };

        return this.post(url, {}, config);
    };
};

angular.module('gw-um-submission')
    .service('createCollaborationNoteRepository', CreateCollaborationNoteRepository);
